<template>
  <div class="chart meter-health-chart" ref="chartContainer">

  </div>
</template>
<script>
require('@chartisan/chartjs');
export default {
  name: "MeterHealthChart",
  props: {
    url: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: "300px",
    }
  },
  mounted() {
    this.$refs.chartContainer.style.height = this.height;
    const chart = new Chartisan({
      el: this.$refs.chartContainer,
      url: this.url,
      hooks: new ChartisanHooks()
          .responsive()
          .colors()
          .legend({position: 'bottom'})
          .title('Meter Health')
          .datasets('pie')
          .pieColors(["yellow", "red", "green"])
    });
  }
}
</script>

<style scoped>

</style>
